import React from 'react';
import PageTitle from '../PageTitle';
import { Helmet } from 'react-helmet';
import ContactInfo from '../ContactInfo';

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>I'm Your Huckleberry | Terms and Conditions</title>

      </Helmet>
      <PageTitle title={'Terms and Conditions'} />
      <div className="container py-5">
        <h1>Terms and Conditions for I'm Your Huckleberry LLC</h1>
        <p>
          <strong>Effective Date:</strong> January 1st 2025
        </p>

        <p>
          Welcome to I'm Your Huckleberry LLC! These Terms and Conditions (“Agreement”) govern the
          use of our cleaning services and website. By booking services, using our website, or
          engaging with our business in any way, you agree to the following terms. Please read them
          carefully.
        </p>

        <h2>1. Services Provided</h2>
        <p>
          We provide residential and commercial cleaning services, maid services, and housekeeping
          services, including but not limited to standard residential and commercial cleaning,
          construction clean-up, move-in/move-out cleaning, and deep cleaning services. Specific
          details about the services you require will be agreed upon during the booking process.
        </p>

        <h2>2. Booking and Scheduling</h2>
        <ul>
          <li>All services must be booked in advance by phone.</li>
          <li>
            By booking a cleaning service, you confirm that the information you provide is accurate
            and up to date.
          </li>
          <li>
            We will provide you with an estimated time for service completion. However, we cannot
            guarantee exact times, as the duration of cleaning may vary based on the size and
            condition of the space.
          </li>
        </ul>

        <h2>3. Payment Terms</h2>
        <ul>
          <li>
            Payment for services is due upon completion of the cleaning. We accept Visa, Mastercard,
            Discover, American Express, Apple Pay, PayPal, Venmo, and checks.
          </li>
          <li>
            If you choose to pay by credit card, Apple Pay, PayPal, or Venmo, transactions include a
            2.99% transaction fee.
          </li>
          <li>Late payments may incur additional fees or result in a suspension of services.</li>
        </ul>

        <h2>4. Cancellations and Rescheduling</h2>
        <ul>
          <li>
            Cancellations or rescheduling must be made at least 1 week before your scheduled
            appointment.
          </li>
          <li>
            If you cancel within 1 week of your scheduled service, you may be subject to a
            cancellation fee of $100 or a percentage of the service cost.
          </li>
          <li>
            If there is no access to the property at the scheduled time, a no-show fee of $100 will
            apply.
          </li>
        </ul>

        <h2>5. Customer Responsibilities</h2>
        <ul>
          <li>
            The customer agrees to provide reasonable access to the property or premises to be
            cleaned. Any locked or restricted areas that you request to be cleaned should be made
            accessible, or you should notify us in advance.
          </li>
          <li>
            It is the customer’s responsibility to secure any valuables, fragile items, or items
            that may be easily damaged. I'm Your Huckleberry LLC is not liable for any damage to
            personal property, furniture, or items unless caused by negligence on our part.
          </li>
          <li>
            If there are pets on the premises, you must inform us prior to the service. You are
            responsible for securing pets during cleaning.
          </li>
        </ul>

        <h2>6. Satisfaction Guarantee</h2>
        <ul>
          <li>
            I'm Your Huckleberry LLC strives for 100% customer satisfaction. If you are not
            satisfied with our cleaning service, please contact us within 24 hours of the service
            completion. We will make reasonable efforts to resolve any issues at no additional
            charge. However, we cannot guarantee that every stain or imperfection will be removed.
          </li>
        </ul>

        <h2>7. Liability</h2>
        <ul>
          <li>
            I'm Your Huckleberry LLC is not responsible for any pre-existing damage to property,
            furniture, or fixtures.
          </li>
          <li>
            We are not liable for accidents, injuries, or damages that may occur during the
            performance of our services, except in cases of gross negligence by our team members.
          </li>
          <li>
            We are not responsible for damage caused by improperly maintained items or systems
            (e.g., malfunctioning appliances, faulty plumbing, etc.).
          </li>
        </ul>

        <h2>8. Privacy and Data Protection</h2>
        <p>
          By booking and using our services, you agree to our Privacy Policy, which outlines how we
          collect, use, and protect your personal information.
        </p>

        <h2>9. Termination of Service</h2>
        <ul>
          <li>
            I'm Your Huckleberry LLC reserves the right to terminate services if the customer is
            abusive, disruptive, or if payment is not made in accordance with the terms.
          </li>
          <li>
            In the event of termination, any unpaid balances are still due and payable immediately.
          </li>
        </ul>

        <h2>10. Intellectual Property</h2>
        <ul>
          <li>
            All content on our website, including text, graphics, logos, and images, is the property
            of I'm Your Huckleberry LLC and is protected by copyright laws. You may not use,
            reproduce, or distribute any content without our prior written permission.
          </li>
        </ul>

        <h2>11. Amendments to These Terms</h2>
        <ul>
          <li>
            I'm Your Huckleberry LLC reserves the right to update or modify these Terms and
            Conditions at any time. All changes will be posted on our website, and the updated terms
            will take effect immediately upon publication.
          </li>
        </ul>

        <h2>12. Governing Law and Dispute Resolution</h2>
        <ul>
          <li>
            These Terms and Conditions are governed by the laws of [insert your state/country].
          </li>
          <li>
            Any disputes arising out of or related to these terms shall be resolved through binding
            arbitration, and you consent to the jurisdiction of the state or federal courts located
            in Barron County, WI.
          </li>
        </ul>

        <h2>13. Contact Us</h2>
        <p>
          If you have any questions or concerns about these Terms and Conditions, please contact us
          at:
        </p>
        <ContactInfo />
      </div>
    </>
  );
};

export default TermsConditions;
